import { render } from "./StandardView.vue?vue&type=template&id=35e17626&scoped=true"
import script from "./StandardView.vue?vue&type=script&lang=js"
export * from "./StandardView.vue?vue&type=script&lang=js"

import "./StandardView.vue?vue&type=style&index=0&id=35e17626&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e17626"]])

export default __exports__